<template>
  <div class="embedCnt">
    <div v-html="embedCode"></div>
  </div>
</template>

<script>
export default {
  name: 'mediaEmbed',
  components: {},
  data() {
    return {
      loading: true,
      embedCode: null,
    };
  },
  methods: {
    getData() {
      this.$http.get(this.$config.uri('article/embed/34')).then((r) => {
        this.embedCode = r.data;
      });
    },
  },
  mounted() {
    this.getData();
  },
};
</script>


<style scoped lang="scss">
  .embedCnt{
    position: fixed;
    left: 0; top: 0; right: 0; bottom: 0;
    z-index: 991;
    background-color: red;
  }
</style>
